import { Form } from "antd";
import { default as React } from "react";
import { EditableContext } from "./SplittingTransactionEditableTable";

interface EditableRowProps {
  index: number;
}
export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
